import { Token, ObjectivesApi, PhotoType, ValidateQuestPhotoSuccessResponse, ValidateQuestPhotoFailResponse } from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useMutation} from "@tanstack/react-query";

interface ValidateQuestPhotoParams {
    photo: Blob;
    /*
     * Pass EITHER photoType OR eventTypeId. eventTypeId is the
     * data-driven path used by Brand Challenge hubs (Full Throttle) whose
     * objectives carry `triggerEvent.eventTypeId` — the backend resolves
     * photoType from the EventType's fields.devourPhotoType.options[0].
     */
    photoType?: PhotoType;
    eventTypeId?: string;
    testMode?: string;
}

async function validateQuestPhoto(fullToken: Token, {
    photo,
    photoType,
    eventTypeId,
    testMode,
}: ValidateQuestPhotoParams): Promise<ValidateQuestPhotoSuccessResponse | ValidateQuestPhotoFailResponse> {
    try {
        return await new ObjectivesApi(getConfig(fullToken)).createEventPipelineValidateQuestPhoto({
            photo: photo,
            photoType,
            eventTypeId,
            testMode,
        });
    } catch (error) {
        console.log("Error validating quest photo:", error);
        if (error && typeof error.json === "function") {
            const jsonResult = await error.json() as ValidateQuestPhotoFailResponse;
            return jsonResult;
        }
        // Return a fail response for non-JSON errors
        return { success: false } as ValidateQuestPhotoFailResponse;
    }

}

export function useValidateQuestPhoto(fullToken: Token) {

    return useMutation({
        mutationKey: ["validate-quest-photo", fullToken?.id],
        mutationFn: (params: Omit<ValidateQuestPhotoParams, "fullToken">) =>
            validateQuestPhoto(fullToken, params),
    });
}